import { useSearch } from "@usereactify/search";
import React, { useContext } from "react";
import { ResultStatsContext } from "../../context/ResultStatsContext";

export type ShowingResultsProps = {
  resultsMetaClasses?: string;
};

export const ShowingResults: React.FC<ShowingResultsProps> = (props) => {
  const { displayedResults, numberOfResults } = useContext(ResultStatsContext);
  const { resultsMetaClasses } = props;

  const { searchTerm } = useSearch();
  const shouldDisplay: boolean = Boolean(!!searchTerm && searchTerm?.length > 0 && displayedResults && numberOfResults);

  return shouldDisplay ? (
    <h2 className={resultsMetaClasses}>
      Showing {displayedResults} of {numberOfResults} results for ‘{searchTerm}’
    </h2>
  ) : null;
};
